import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import FlexRow from '../../../../components/molecules/FlexRow'

function NextUpLink ({ linkedList, currentScheduleId }) {
  const currentNode = useMemo(() => {
    if (!linkedList || !currentScheduleId) return null
    return linkedList.find(node => node.scheduleId === currentScheduleId)
  }, [linkedList, currentScheduleId])

  if (!currentNode?.next) return null

  return (
    <FlexRow className='justify-end mt-5'>
      <Link
        to={`/denali-ai/reading-list/item/${currentNode.next}`}
        className='font-serif font-size-sm'
      >
        <em>Next Up:</em> {currentNode.nextName} →
      </Link>
    </FlexRow>
  )
}

NextUpLink.propTypes = {
  linkedList: PropTypes.arrayOf(PropTypes.shape({
    scheduleId: PropTypes.string.isRequired,
    name: PropTypes.string,
    next: PropTypes.string,
    nextName: PropTypes.string
  })),
  currentScheduleId: PropTypes.string
}

export default NextUpLink
